import { Flex, SkeletonText } from '@chakra-ui/react';
import React from 'react';
import './BreadcrumbSkeleton.scss';

const BreadcrumbSkeleton = () => {
  return (
    <Flex className={'breadcrumb-skeleton-container'}>
      <SkeletonText
        noOfLines={1}
        skeletonHeight="7"
        className={'breadcrumb-skeleton-home'}
      />

      <SkeletonText
        noOfLines={1}
        skeletonHeight="7"
        className={'breadcrumb-skeleton-title'}
      />
    </Flex>
  );
};

export default BreadcrumbSkeleton;
